<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch, computed } from 'vue'
import { useProductStore } from '@/stores/product';
import { useI18n } from 'vue-i18n';
import messages from '@/locales/cart/messages';

const props = defineProps({
    article:{
        type: Object,
        required: true
    },
    order:{
        type: Boolean,
        default: false
    },
    showHT:{
        type: Boolean,
        default: false
    }
});
const emits = defineEmits(['delete','update']);

const { locale, t } = useI18n({
    useScope: 'global',
    messages: messages
})
const ProductStore = useProductStore()
const quantity = ref(props.article.qt)
const product = ref(null)
const article = computed(()=>{
    if(product.value){
        return product.value.articles.find((a)=>a.id == props.article.article_id)
    }
    else{
        return {
            id: false,
            unavailable_delai : 'N/A',
            prices : {
                discount : 9999,
                official : 9999
            }
        }
    }
})
const reloadTimeout = ref(null);

function loadProduct(){
    ProductStore.getProductById(props.article.product_id).then((res)=>{
        product.value = res
        if(res.reload){
            // we try to reload the product in 1s
            reloadTimeout.value = setTimeout(() => {
                loadProduct()
            }, 5000)
        }
    }).catch((err)=>{
        console.log(err)
    })
}

watch(()=>props.article.qt, (newVal)=>{
    quantity.value = newVal
})
watch(()=>props.article.product_id, (newVal)=>{
    loadProduct()
})
onMounted(()=>{
    loadProduct()
})
onUnmounted(()=>{
    if(reloadTimeout){
        clearTimeout(reloadTimeout.value)
    }
})

const name = computed(()=>{
    if(article.value && product.value){
        let name = product.value.content[locale.value].name;
        if(article.value.name!=''){
            name += ' - '+article.value.name
        }
        return name
    }
    return ''
})
const total = computed(()=>{
    if(article.value && quantity.value>0){
        return (prix.value * quantity.value).toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
    return '0,00'
})
const img = computed(()=>{
    if(product.value && product.value.images && product.value.images[0]){
        return `https:///assets.zokkus.com/images/format-128x128/${product.value.images[0].name}`
    }
    return '/img/no-picture.jpg';
})
const prix = computed(()=>{
    if(article.value){
        if(props.showHT){
            // we devide the price by 1.2 to get the price without taxes
            return (article.value.prices.discount/1.2)
        }
        return article.value.prices.discount
    }
    return 0
})
const prixOfficial = computed(()=>{
    if(article.value && article.value.prices.official > article.value.prices.discount){
        if(props.showHT){
            // we devide the price by 1.2 to get the price without taxes
            return (article.value.prices.official/1.2)
        }
        return article.value.prices.official
    }
    return false
})
const articlePrice = computed(()=>{
    if(article.value){
        return prix.value.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
    return 'N/A €'
})
const articlePriceOfficial = computed(()=>{
    if(article.value && article.value.prices.official > article.value.prices.discount){
        return prixOfficial.value.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
    return false
})

const availableText = computed(()=>{
    if(props.article.available){
        return t('product.available')
    }
    return article.value.unavailable_delai.replace(/{{between}}/g, t('product.between')).replace(/{{and}}/g, t('product.and')).replace(/{{days}}/g, t('product.days'))
})

const productLink = computed(()=>{
    if(product.value){
        const to = {
            name: locale.value+'.product',
            params: {
                slug: product.value.slug+'_'+product.value.id
            }
        }
        if(product.value.articles.length>1){
            to.query={variation :article.value.name}
        }
        return to
    }
    return ''
})

</script>
<template>
<div class="carte_line" v-if="article.id!=false">
    <router-link :to="productLink" class="carte_line_img">
        <img :src="img" :alt="name" />
    </router-link>
    <div class="carte_line_content">
        <h3>{{ name }}</h3>
        <div class="carte_line_price">
            <span v-if="articlePriceOfficial" class="old_price">{{ articlePriceOfficial }}€</span>
            <span class="kase_price">{{ articlePrice }}€</span>
        </div>
        <div class="carte_line_quantity">
            <v-btn  v-if="!props.order" class="qt_change_btn" icon @click="emits('update', {id: props.article.article_id, qt: props.article.qt-1})" variant="text" size="small">
                -
            </v-btn>
            <input  v-if="!props.order" type="text" v-model.number="quantity" @change="emits('update',{id: props.article.article_id, qt: quantity})" />
            <span v-else>{{ quantity }}</span>
            <v-btn  v-if="!props.order" class="qt_change_btn" icon @click="emits('update', {id: props.article.article_id, qt: props.article.qt+1})" variant="text" size="small">
                +
            </v-btn>
        </div>
        <div class="carte_line_total">
            <span>{{ total }}€</span>
        </div>
        <div class="carte_line_availability" :class="{ 'unavailable': !props.article.available }">
            {{ availableText }}  
        </div>
            
    </div>
    <v-btn v-if="!props.order" class="btn-delete" icon @click="emits('delete', props.article.article_id)" size="small" color="red" variant="text">
        x
    </v-btn>
</div>
</template>